import {
  setCustomer,
  requestRecharges as creatorsRequestRecharges,
} from "@/redux/ducks/customer";
import { ReducersTypes } from "@/redux/reducers/Models";
import { RechargesItems } from "@/redux/sagas/extract/recharges";
import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const useRecharges = (callbackRequest?: () => void) => {
  const dispatch = useDispatch();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);

  const handleRecharges = (
    success: boolean,
    items?: RechargesItems["items"],
  ) => {
    dispatch(
      setCustomer({
        recharges: {
          ...customer?.recharges,
          isLoading: false,
        },
      }),
    );

    callbackRequest?.();

    if (!success) return;

    dispatch(
      setCustomer({
        recharges: {
          ...customer?.recharges,
          isLoading: false,
          items: items!,
        },
      }),
    );
  };

  const requestRecharges = (period?: "30" | "60" | "90") => {
    if (customer?.recharges?.isLoading) return;

    dispatch(
      setCustomer({
        recharges: {
          ...customer?.recharges,
          isLoading: true,
          items: null,
        },
      }),
    );
    dispatch(
      creatorsRequestRecharges({
        period: period ?? customer?.recharges?.selectedFilter ?? "90",
        callback: handleRecharges,
      }),
    );
  };

  const setSelectedFilter = (period: "30" | "60" | "90" | null) => {
    if (customer?.recharges?.isLoading) return;

    dispatch(
      setCustomer({
        recharges: {
          ...customer?.recharges,
          selectedFilter: period,
        },
      }),
    );
  };

  useEffect(() => {
    if (
      !customer?.recharges?.items ||
      moment(customer?.recharges?.lastUpdated).isBefore(
        moment().subtract(10, "minutes"),
      )
    ) {
      setSelectedFilter("30");
      requestRecharges("30");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isLoading: customer?.recharges?.isLoading,
    items: customer?.recharges?.items,
    lastUpdated: customer?.recharges?.lastUpdated,
    selectedFilter: customer?.recharges?.selectedFilter,
    setSelectedFilter,
    requestRecharges,
  };
};

export default useRecharges;
